import React from "react";
import "./Modal.scss";
import { Button } from "../form";
import { logoutmodal } from "../../assets/icons";
import CustomModal from "./CustomModal";
const LogoutModal = ({ show, close, logoutHandler, text = "" }) => {
  return (
    <>
      <CustomModal
        show={show}
        handleClose={close}
        className={"logoutModal"}
        closeButton={false}
      >
        <div className="wrap_log_modal">
          <figure>
            <img src={logoutmodal} alt="icon" />
          </figure>
          {text ? (
            <h3>{text}</h3>
          ) : (
            <h3>
              Are you sure you want to <br /> logout?
            </h3>
          )}

          <div className="button_wrap button_center">
            <Button className={"light"} onClick={logoutHandler}>
              Yes
            </Button>
            <Button onClick={close}>No</Button>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default LogoutModal;
